/* Sentopia: preserve server-rendered content; activate offscreen Alpine sections near use. */
(() => {
  if (window.sentopiaPerformance || window.Shopify?.designMode) return;
  window.sentopiaPerformance = true;
  if (!('IntersectionObserver' in window)) {
    for (const img of document.querySelectorAll('img[data-sentopia-card-src]')) {
      const set = img.getAttribute('data-sentopia-card-srcset');
      if (set) img.setAttribute('srcset', set);
      img.setAttribute('src', img.getAttribute('data-sentopia-card-src'));
      img.removeAttribute('data-sentopia-card-srcset');
      img.removeAttribute('data-sentopia-card-src');
    }
    return;
  }
  const imageRoot = document.querySelector('#MainContent');
  if (imageRoot) {
    const hydrate = img => {
      const set = img.getAttribute('data-sentopia-card-srcset');
      const src = img.getAttribute('data-sentopia-card-src');
      if (set) img.setAttribute('srcset', set);
      if (src) img.setAttribute('src', src);
      img.removeAttribute('data-sentopia-card-srcset');
      img.removeAttribute('data-sentopia-card-src');
      imageObserver.unobserve(img);
    };
    const imageObserver = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) hydrate(entry.target);
    }, {rootMargin:'300px 60px'});
    const watchImages = node => {
      if (node.nodeType !== 1) return;
      if (node.matches('img[data-sentopia-card-src]')) imageObserver.observe(node);
      for (const img of node.querySelectorAll('img[data-sentopia-card-src]')) imageObserver.observe(img);
    };
    watchImages(imageRoot);
    // Section-rendered collections and slider clones keep the same on-demand loading.
    const imageChanges = new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) watchImages(node);
    });
    imageChanges.observe(imageRoot, {childList:true,subtree:true});
    imageRoot.addEventListener('pointerover', event => {
      const img = event.target.closest('picture[data-sentopia-deferred]')?.querySelector('img[data-sentopia-card-src]');
      if (img) hydrate(img);
    }, {passive:true});
  }
  document.addEventListener('alpine:init', () => {
    const main = document.querySelector('#MainContent.theme-template-index');
    if (!main || typeof Alpine.initTree !== 'function') return;
    const waiting = new Set(), ready = [], scheduled = new Set();
    let frame = 0;
    const finish = root => {
      if (!waiting.has(root)) return;
      waiting.delete(root); observer.unobserve(root);
      root.removeAttribute('x-ignore');
      root.removeAttribute('data-sentopia-pending');
      // Removing x-ignore lets Alpine run its own directive cleanup first.
      queueMicrotask(() => { if (root.isConnected) Alpine.initTree(root); });
    };
    const drain = () => {
      frame = 0;
      const root = ready.shift();
      if (root) { scheduled.delete(root); finish(root); }
      if (ready.length) frame = requestAnimationFrame(drain);
    };
    const enqueue = root => {
      if (!waiting.has(root) || scheduled.has(root)) return;
      scheduled.add(root); ready.push(root);
      if (!frame) frame = requestAnimationFrame(drain);
    };
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) enqueue(entry.target);
    }, {rootMargin:'450px 0px'});
    for (const root of main.children) {
      if (!root.classList.contains('shopify-section') || root.querySelector('[data-sentopia-hero]') || root.hasAttribute('x-ignore')) continue;
      if (root.getBoundingClientRect().top < innerHeight + 150) continue;
      root.setAttribute('x-ignore','');
      root.setAttribute('data-sentopia-pending','');
      waiting.add(root);
    }
    document.addEventListener('alpine:initialized', () => {
      for (const root of waiting) observer.observe(root);
    }, {once:true});
    // Keyboard and fast pointer navigation do not depend on observer timing.
    const activateTarget = event => {
      const root = event.target.closest?.('[data-sentopia-pending]');
      if (root) finish(root);
    };
    main.addEventListener('pointerdown', activateTarget, {capture:true,passive:true});
    main.addEventListener('focusin', activateTarget, true);
    window.addEventListener('pagehide', () => {cancelAnimationFrame(frame);frame=0;observer.disconnect();});
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      for (const root of waiting) observer.observe(root);
      if (ready.length && !frame) frame=requestAnimationFrame(drain);
    });
  }, {once:true});
})();
